const UIStrategy = require('./ui_strategy');
const BASE_TOP_IN_PIXEL = 10;
const HIDDEN_CLASS = 'odf-hidden';

class UIStrategyCustomList extends UIStrategy {
    constructor($selectorWrapper, ancillaryContainer, templates, keys, primeInfo) {
        super($selectorWrapper, ancillaryContainer, templates, keys, primeInfo);

        this.templates.list = templates.list;
        this.templates.wrapper = templates.wrapper;
    }

    getSelectedBaggageData(evt = {}) {
        const $el = $(evt.currentTarget);
        return $el.data();
    }

    toggle(parent, hide) {
        super.toggle(parent, hide);

        const $combo = this.$selectorWrapper.find('.baggage_selector_list');
        $combo.toggleClass(HIDDEN_CLASS, hide);

        if (!hide && parent !== undefined) {
            window.addEventListener('click', () => {
                this.toggle(parent, true);
            }, {
                once: true,
                capture: true,
            });

            this.moveComboIfHidden($combo, parent);
        }
    }

    moveComboIfHidden($combo, parent) {
        const $ancillaryContainer = $(this.ancillaryContainer);
        const scrollTop = $ancillaryContainer.scrollTop();
        const $callerButton = parent.$el.find('.select_baggage_view');
        const callerButtonPosition = $callerButton.position();
        const callerButtonTopPosition = callerButtonPosition.top + scrollTop;
        const callerButtonLeftPosition = callerButtonPosition.left;

        const buttonHeight = $callerButton.innerHeight();
        const buttonWidth = $callerButton.innerWidth();
        const comboWidth = $combo.innerWidth();
        const top = callerButtonTopPosition + buttonHeight + BASE_TOP_IN_PIXEL;
        const left = callerButtonLeftPosition - comboWidth + buttonWidth;

        $combo.css({
            top,
            left,
        });
    }
}

module.exports = UIStrategyCustomList;
